import { Container } from "@mui/material";

import { styled as Style } from "@mui/material/styles";

export const Wrapper = Style(Container)(({ theme }) => ({
  margin: "auto",
  padding: "0 !important",
  // maxWidth: '1920px',
  height: "calc(100vh - 64px)",
  color: "#FCFCFF",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  overflow: "auto",
  marginTop: "64px",
  [theme.breakpoints.down('sm')]: {
    marginTop: "55px",
  },
}));

